export default function (selector) {
  return function () {
    return this.matches(selector);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/matcher.js
// module id = 444
// module chunks = 0